<template>
  <div class="px-10">
    <v-row no-gutters>
      <v-col>
        <v-icon medium>
          mdi-clipboard-alert
        </v-icon>
        <span class="font-16 font-weight-bold mx-2">Discipline</span>
        <employee-profile-discipline-dialog-create
          v-if="!isMyProfile && $hasPermissionTo(['create employee disciplines'])"
          :employee-uid="employeeUid"
          @created="loadEmployeeDisciplinaryCases"
        />
      </v-col>

      <v-col
        v-if="disciplinaryCases.length > 0 && $hasPermissionTo(['generate disciplinary report'])"
        cols="1"
      >
        <v-btn
          color="primary"
          :loading="progressing"
          @click="generate"
        >
          <v-icon class="mr-1">
            mdi-download
          </v-icon>
          Download
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col
        v-if="disciplinaryCases.length > 0"
        cols="12"        
      >
        <v-timeline>
          <v-timeline-item
            v-for="(disciplinaryCase, i) in disciplinaryCases"
            :key="i"
            small
            color="error"
          >
            <template v-slot:opposite>
              <span :class="`headline font-weight-bold error--text`"> 
                {{ $moment(disciplinaryCase.date_of_action_taken, 'YYYY-MM-DD').format('DD MMM YYYY') }} 
              </span>
            </template>

            <v-card
              color="error"
              dark
            >
              <v-list
                one-line
                color="error"
              >
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium text-capitalize">
                      {{ disciplinaryCase.disciplinary_category.name }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="text-uppercase pt-1">
                      created by {{ disciplinaryCase.created_by }} at {{ $moment(disciplinaryCase.created_at).format('D MMMM YYYY hh:mm A') }}
                    </v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action v-if="!isMyProfile && ($hasPermissionTo(['update employee disciplines']) || $hasPermissionTo(['delete employee disciplines']) ||$hasPermissionTo(['upload employee disciplines document']))">
                    <v-menu
                      bottom
                      right
                      nudge-right="30px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          v-on="on"                        
                        >
                          <v-icon>more_vert</v-icon>
                        </v-btn>
                      </template>
                  
                      <v-list>
                        <v-list-item
                          v-if="!isMyProfile && $hasPermissionTo(['update employee disciplines'])"
                          @click="$refs.editDialog.toggleDialog(disciplinaryCase)"
                        >
                          <v-list-item-title>                             
                            Edit
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-if="!isMyProfile && $hasPermissionTo(['upload employee disciplines document'])"
                          @click="$refs.uploadDialog.toggleDialog(disciplinaryCase)"
                        >
                          <v-list-item-title>                             
                            Add File
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-if="!isMyProfile && $hasPermissionTo(['delete employee disciplines'])"
                          @click="$refs.deleteDialog.toggleDialog(disciplinaryCase)"
                        >
                          <v-list-item-title>
                            Delete
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
              <v-card-text
                class="white text--primary"
              >
                <v-row no-gutters>
                  <v-col cols="3">
                    <span class="font-weight-bold"> Payroll Company </span>
                  </v-col>
                  <v-col cols="1">
                    :
                  </v-col>
                  <v-col cols="8">
                    <!-- {{ disciplinaryCase.employee.company_employees }} -->
                    <span
                      v-for="(company, index) in filterPayrollCompany(disciplinaryCase, disciplinaryCase.date_of_misconduct)"
                      :key="company.id"
                    >
                      {{ company.company.name }}
                      <span v-if="index < filterPayrollCompany(disciplinaryCase, disciplinaryCase.date_of_misconduct).length - 1">, </span>
                    </span>
                  </v-col>
                </v-row>

                <v-row no-gutters>
                  <v-col cols="3">
                    <span class="font-weight-bold"> Type of Misconduct </span>
                  </v-col>
                  <v-col cols="1">
                    :
                  </v-col>
                  <v-col cols="8">
                    <span v-html="disciplinaryCase.type_of_misconduct.name" />
                  </v-col>
                </v-row>

                <v-row no-gutters>
                  <v-col cols="3">
                    <span class="font-weight-bold">Date of Misconduct</span>
                  </v-col>
                  <v-col cols="1">
                    :
                  </v-col>
                  <v-col cols="8">
                    <span>{{ $moment(disciplinaryCase.date_of_misconduct, 'YYYY-MM-DD').format('DD MMM YYYY') }}</span>
                  </v-col>
                </v-row>

                <v-row no-gutters>
                  <v-col cols="3">
                    <span class="font-weight-bold"> Disciplinary Action</span>
                  </v-col>
                  <v-col cols="1">
                    :
                  </v-col>
                  <v-col cols="8">
                    <span>{{ disciplinaryCase.disciplinary_action.name }}</span>
                  </v-col>
                </v-row>

                <v-row no-gutters>
                  <v-col cols="3">
                    <span class="font-weight-bold">Remarks</span>
                  </v-col>
                  <v-col cols="1">
                    :
                  </v-col>
                  <v-col cols="8">
                    <p 
                      class="mt-n5" 
                      style="white-space: pre-line;"
                    >
                      {{ 
                        truncate[disciplinaryCase.id] ? 
                          getTruncatedDescription(disciplinaryCase.remarks ==='null'?'':disciplinaryCase.remarks) : 
                          (disciplinaryCase.remarks ==='null'?'':disciplinaryCase.remarks)
                      }}
                    </p>
                    <div v-if="requireTruncation(disciplinaryCase.remarks ==='null'?'':disciplinaryCase.remarks)">
                      <a 
                        v-if="truncate[disciplinaryCase.id]" 
                        @click.stop="$set(truncate, disciplinaryCase.id, false)"
                      >Show more ...</a> 
                      <a 
                        v-else 
                        @click.stop="$set(truncate, disciplinaryCase.id, true)"
                      >Show less ...</a>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
              <div v-if="disciplinaryCase.documents.length > 0">
                <v-divider />

                <v-card-subtitle class="font-weight-bold white black--text pb-0">
                  {{ disciplinaryCase.documents.length }} documents
                </v-card-subtitle>
              </div>

              <v-container class="white py-0 px-4">
                <v-row>
                  <template v-for="document in disciplinaryCase.documents">
                    <v-col 
                      :key="document.id"
                      cols="6"
                      class="px-1 py-2"
                    >
                      <v-chip
                        color="blue-grey lighten-3"
                        link
                        :href="document.file_url"
                        target="_blank"
                      >
                        <v-icon
                          color="red"
                          left
                        >
                          mdi-file
                        </v-icon>
                        <span class="text-truncate"> {{ document.file_name }} </span>
                      </v-chip> 
                    </v-col>
                  </template>
                </v-row>
              </v-container>
            </v-card> 
          </v-timeline-item>
        </v-timeline> 

        <employee-profile-discipline-dialog-edit
          ref="editDialog"
          :employee-uid="employeeUid"
          @updated="loadEmployeeDisciplinaryCases"
        />
        <employee-profile-discipline-dialog-upload
          ref="uploadDialog"
          :employee-uid="employeeUid"
          @uploaded="loadEmployeeDisciplinaryCases"
        />
        <employee-profile-discipline-dialog-delete
          ref="deleteDialog"
          :employee-uid="employeeUid"
          @deleted="loadEmployeeDisciplinaryCases"
        />
      </v-col>

      <v-col
        v-else
        cols="12"
      >
        <span class="mx-2"> No data available </span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    components: {
      EmployeeProfileDisciplineDialogCreate: () => import('@/components/hris/employee/profile/discipline/DialogCreate'),
      EmployeeProfileDisciplineDialogEdit: () => import('@/components/hris/employee/profile/discipline/DialogEdit'),
      EmployeeProfileDisciplineDialogDelete: () => import('@/components/hris/employee/profile/discipline/DialogDelete'),
      EmployeeProfileDisciplineDialogUpload: () => import('@/components/hris/employee/profile/discipline/DialogUpload'),

    },
    props: {
      employeeUid: {
        type: String, 
        default: '',
      },
    },
    data () {
      return {
        disciplinaryCases: [],
        truncate: [],
        loading: false,
        progressing: false,
      }
    },
    computed: {  
      ...mapState({ isCurrentUser: 'isMyProfile' }),
      isMyProfile () {
        return this.$store.state.isMyProfile
      },
    },
    watch: {
      employeeUid: {
        immediate: true,
        handler (value) {
          if (value) {
            this.disciplinaryCases.splice(0, this.disciplinaryCases.length)
            this.loadEmployeeDisciplinaryCases()
          }
        },
      },
    },
    methods: {
      loadEmployeeDisciplinaryCases () {
        this.loading = true

        this.$api.employeeDisciplineCases().list(this.employeeUid)
          .then(response => {
            this.disciplinaryCases = _.orderBy(response.data, ['date_of_action_taken'], ['desc'])
            this.setTruncation(this.disciplinaryCases)
            
            this.loading = false
          })
      },
      generate () {
        this.progressing = true

        this.$api.employeeReports().disciplinaryReport({ employeeUids: [this.employeeUid] })
          .then(res => {
            let blob = new Blob([res.data], { type: res.data.type })
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.setAttribute('download', 'EmployeeDisciplinaryReport.xlsx')
            link.click()

            this.progressing = false
          })
      },
      setTruncation (disciplinaryCases, length = 200) {
        disciplinaryCases.map(disciplinaryCase => {
          if (disciplinaryCase.remarks) {
            if (disciplinaryCase.remarks.length > length) {
              this.$set(this.truncate, disciplinaryCase.id, true)
            }
          }
        })
      },
      getTruncatedDescription (description, length = 200, ending = '...') {
        if (description.length > length) {
          return description.substring(0, length - ending.length) + ending
        }

        return description
      },
      requireTruncation (description, length = 200) {
        if (description) {
          return description.length > length
        }
        return false
      },

      filterPayrollCompany (disciplinaryCase, date) {
        let filteredCompanyEmployees = []

        let matchedCompanyEmployees = disciplinaryCase.employee.company_employees.filter(payrollCompany => {
          return payrollCompany.start_date <= date && (!payrollCompany.end_date || payrollCompany.end_date >= date) 
        })

        if (matchedCompanyEmployees.some(ce => ce.is_active_pay_status === 1)) {
          filteredCompanyEmployees = matchedCompanyEmployees.filter(ce => ce.is_active_pay_status === 1)
        } else {
          filteredCompanyEmployees = matchedCompanyEmployees
        }

        return filteredCompanyEmployees
      },
    },
  }
</script>
